import { useQueryClient } from "@tanstack/react-query";
import { Outlet } from "react-router-dom";

import { COLLECTION_ACTIONS } from "~/components/services/hooks/useOrdersWithPermissions";
import { useTeam } from "~/contexts/TeamProvider.tsx";
import { useCableSubscription } from "~/hooks/useCableSubscription";
import { orderQueries } from "~/pages/services/queryKeys";

export default function ServicesSubscriptionsGate() {
  const { team } = useTeam();

  if (!team) {
    throw new Error("Current team is not available.");
  }

  const queryClient = useQueryClient();

  useCableSubscription(
    "OrdersChannel",
    {},
    {
      received: (data) => {
        switch (data.action) {
          case "pending-count-changed": {
            queryClient.invalidateQueries({
              queryKey: orderQueries.pending({
                teamId: team.id,
                actions: COLLECTION_ACTIONS,
              }),
            });
            // A paid order may have moved to Past Orders.
            queryClient.invalidateQueries({
              queryKey: orderQueries.lists(team.id),
            });

            break;
          }
          default:
            break;
        }
      },
    },
  );

  return <Outlet />;
}
